import { getPercentSchema, getStringSchema, getSelectSchema, getBooleanSchema } from 'src/compass/shared/schemas';
import * as Yup from 'yup';
import UniqueAgentSchema from './UniqueAgentSchema';

export const AsOfTrailsSchema = UniqueAgentSchema.of(
  Yup.object().shape({
    percent: getPercentSchema('Percent'),
    agentId: getSelectSchema('Agent'),
  })
);

export const LRPAgenciesSchema = Yup.object().shape({
  name: getStringSchema(100),
  agencyNbr: getStringSchema(20, 'Agency#'),
  claimsSharepointSiteId: getSelectSchema('Sharepoint Site'),
  claimsSharepointRoot: getStringSchema(255, 'Sharepoint Root'),
  isActive: getBooleanSchema('Active'),
  asOf: Yup.object({
    asOfTrails: AsOfTrailsSchema,
  }),
});
